
export interface IframeSkeletonProps {
  title?: string;
}

const IframeSkeleton = ({ title = "Loading..." }: IframeSkeletonProps): JSX.Element => (
  <svg
    role="img"
    width="719"
    height="148"
    aria-labelledby="loading-aria"
    viewBox="0 0 719 148"
    preserveAspectRatio="none"
  >
    <title id="loading-aria">{title}</title>
    <rect x="0" y="0" width="100%" height="100%" clipPath="url(#clip-path)" style={{ fill: 'url("#fill")' }} />
    <defs>
      <clipPath id="clip-path">
        <rect x="13" y="8" rx="6" ry="6" width="133" height="11" />
        <rect x="13" y="8" rx="6" ry="6" width="133" height="11" />
        <rect x="13" y="36" rx="6" ry="6" width="100" height="11" />
        <rect x="13" y="36" rx="6" ry="6" width="100" height="11" />
        <rect x="171" y="36" rx="6" ry="6" width="100" height="11" />
        <rect x="171" y="36" rx="6" ry="6" width="100" height="11" />
        <rect x="13" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="13" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="41" y="127" rx="6" ry="6" width="40" height="11" />
        <rect x="41" y="127" rx="6" ry="6" width="40" height="11" />
        <rect x="352" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="352" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="13" y="59" rx="6" ry="6" width="150" height="11" />
        <rect x="13" y="59" rx="6" ry="6" width="150" height="11" />
        <rect x="171" y="59" rx="6" ry="6" width="150" height="11" />
        <rect x="171" y="59" rx="6" ry="6" width="150" height="11" />
        <rect x="329" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="329" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="397" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="397" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="465" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="465" y="59" rx="6" ry="6" width="60" height="11" />
        <rect x="101" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="101" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="440" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="440" y="102" rx="6" ry="6" width="70" height="11" />
        <rect x="189" y="102" rx="6" ry="6" width="145" height="11" />
        <rect x="189" y="102" rx="6" ry="6" width="145" height="11" />
        <rect x="528" y="102" rx="6" ry="6" width="145" height="11" />
        <rect x="528" y="102" rx="6" ry="6" width="145" height="11" />
      </clipPath>
      <linearGradient id="fill">
        <stop offset="0.599964" stopColor="#f3f3f3" stopOpacity="1">
          <animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stopColor="#ecebeb" stopOpacity="1">
          <animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stopColor="#f3f3f3" stopOpacity="1">
          <animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1" dur="2s" repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
  </svg>
);

export default IframeSkeleton;
